export function taskNumberLabel(taskNumber: number) { return `T-${taskNumber}`; }

export function parseTaskNumber(value: string) {
  const match = /^T-(\d+)$/i.exec(value.trim());
  return match ? Number(match[1]) : null;
}
